import { reduce } from 'lodash';

import { Size } from '@/constants';

const allSizes = Object.values(Size);

export const getStylesWithSize = (className: (size: Size) => string, valid: (size: Size) => boolean) =>
  reduce(allSizes, (data, size) => ({ ...data, [className(size)]: valid(size) }), {});
